import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints';

export async function getFormConfiguration(formId){
    let formConfigurationResponse = await axios.get(`${LEADS_ENDPOINT}/form/configuration/?formId=${formId}`)
    
    return formConfigurationResponse?.data?.data
}